// extracted by mini-css-extract-plugin
export default {"button":"Button_button__A76z0","disabled":"Button_disabled__H8GL6","text":"Button_text__vK8pB","img":"Button_img__AmPr8"};